import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const SaasEngineering = () => {
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 })

    return (
        <div className="w-full mx-auto p-6 lg:px-12 lg:py-16 text-zinc-800 dark:text-zinc-200 text-sm" ref={ref}>
            <div className="grid lg:grid-cols-2 gap-12 items-center justify-between">

                <motion.div 
                    className="lg:w-10/12 space-y-6 lg:order-2"
                    initial={{ opacity: 0, x: 50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="flex flex-row text-zinc-800 dark:text-zinc-200 font-light items-center justify-between">
                        <div className="flex justify-start space-x-3 items-center">
                            <span className="text-purple-600 dark:text-purple-400 font-mono text-xl font-bold">03</span>
                            <span className="text-3xl lg:text-4xl font-bold text-zinc-900 dark:text-white">AI Tool Stack Recommendations</span>
                        </div>
                    </div>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        Navigating the fast-moving AI vendor landscape can be daunting. We audit your operations to select, bundle, and recommend cost-effective, off-the-shelf AI software combinations.
                    </p>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        We audit tool prices, data privacy policies, and API capabilities to provide an optimized stack (including OpenAI, Anthropic, Perplexity, and custom workflows) that keeps subscription overhead low.
                    </p>
                </motion.div>

                <motion.div 
                    className="mx-auto lg:w-9/12 w-full lg:order-1"
                    initial={{ opacity: 0, x: -50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="p-6 rounded-2xl border border-slate-200 dark:border-purple-500/20 bg-white dark:bg-[#202222] shadow-[0_4px_20px_rgba(0,0,0,0.03)] dark:shadow-[0_0_35px_rgba(168,85,247,0.08)] hover-glow transition-all duration-300">
                        <h4 className="text-sm font-semibold mb-4 text-zinc-900 dark:text-white flex items-center space-x-2">
                            <span>Recommended Tool Stacks</span>
                        </h4>
                        <div className="space-y-3 font-sans text-xs">
                            <div className="p-3 bg-purple-50 dark:bg-purple-950/10 rounded-lg border border-purple-200 dark:border-purple-500/10 flex justify-between items-center">
                                <span className="font-semibold text-zinc-800 dark:text-zinc-200">LLM APIs</span>
                                <span className="text-purple-600 dark:text-purple-400 font-medium">GPT-4o / Claude 3.5 Sonnet</span>
                            </div>
                            <div className="p-3 bg-purple-50 dark:bg-purple-950/10 rounded-lg border border-purple-200 dark:border-purple-500/10 flex justify-between items-center">
                                <span className="font-semibold text-zinc-800 dark:text-zinc-200">AI Search</span>
                                <span className="text-purple-600 dark:text-purple-400 font-medium">Perplexity API</span>
                            </div>
                            <div className="p-3 bg-purple-50 dark:bg-purple-950/10 rounded-lg border border-purple-200 dark:border-purple-500/10 flex justify-between items-center">
                                <span className="font-semibold text-zinc-800 dark:text-zinc-200">Workflows</span>
                                <span className="text-purple-600 dark:text-purple-400 font-medium">Make.com / LangChain Custom</span>
                            </div>
                        </div>
                    </div>
                </motion.div>

            </div>
        </div>
    )
}

export default SaasEngineering